/* BeautiQ — scrollgebundene Bewegung. Benötigt gsap + ScrollTrigger. */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Farbwechsler ---- */
  [].forEach.call(document.querySelectorAll("[data-colorways]"), function (root) {
    var sw = root.querySelectorAll(".cw-sw");
    var shots = root.querySelectorAll(".cw-shot");
    var names = root.querySelectorAll(".cw-n");
    var glow = root.querySelector(".cw-glow");
    if (!sw.length) return;

    var pick = function (i) {
      [].forEach.call(sw, function (b, j) {
        b.classList.toggle("on", j === i);
        b.setAttribute("aria-selected", j === i ? "true" : "false");
      });
      [].forEach.call(shots, function (s, j) { s.classList.toggle("on", j === i); });
      [].forEach.call(names, function (n, j) { n.classList.toggle("on", j === i); });
      if (glow) {
        var c = getComputedStyle(sw[i]).getPropertyValue("--sw").trim() || "#C8A96A";
        glow.style.background =
          "radial-gradient(50% 50% at 50% 50%, " + c + "33, " + c + "10 48%, transparent 72%)";
      }
    };
    [].forEach.call(sw, function (b, i) {
      b.addEventListener("click", function () { pick(i); });
      b.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();
          var n = (i + (e.key === "ArrowRight" ? 1 : sw.length - 1)) % sw.length;
          sw[n].focus(); pick(n);
        }
      });
    });
    pick(0);
  });

  if (reduce || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    [].forEach.call(document.querySelectorAll("[data-reveal]"), function (e) { e.classList.add("shown"); });
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  /* ---- Überschriften: goldener Wisch von links ---- */
  [].forEach.call(document.querySelectorAll("[data-reveal]"), function (el) {
    ScrollTrigger.create({
      trigger: el, start: "top 84%", once: true,
      onEnter: function () { el.classList.add("shown"); }
    });
  });

  /* ---- Bildparallaxe: Bilder wandern langsamer als die Seite ---- */
  [].forEach.call(document.querySelectorAll(".figure img, .stepfig img, .zonefig img, .panel img, .finalcta-media img"),
    function (img) {
      var box = img.parentElement;
      if (!box) return;
      img.setAttribute("data-px", "");
      gsap.set(img, { scale: 1.14, transformOrigin: "50% 50%" });
      gsap.fromTo(img, { yPercent: -5.5 }, {
        yPercent: 5.5, ease: "none",
        scrollTrigger: { trigger: box, start: "top bottom", end: "bottom top", scrub: 0.6 }
      });
    });

  /* ---- Hero verabschiedet sich beim Wegscrollen ---- */
  var heroMedia = document.querySelector(".hero-media");
  if (heroMedia) {
    gsap.to(heroMedia, {
      scale: 1.07, opacity: .35, ease: "none",
      scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: .5 }
    });
  }

  /* ---- Zahlen zählen hoch (eigener Timer, damit nichts dazwischenfunkt) ---- */
  [].forEach.call(document.querySelectorAll(".stat b, .filmstats b"), function (el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*?)(\d+(?:[.,]\d+)?)([\s\S]*)$/);
    if (!m) return;
    var pre = m[1], post = m[3];
    var target = parseFloat(m[2].replace(",", "."));
    var dec = /[.,]/.test(m[2]) ? 1 : 0;
    var done = false;
    var write = function (v) {
      el.textContent = pre + (dec ? v.toFixed(1).replace(".", ",") : Math.round(v)) + post;
    };
    var run = function () {
      if (done) return;
      done = true;
      var t0 = performance.now(), dur = 1400;
      var step = function (now) {
        var p = Math.min((now - t0) / dur, 1);
        write(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = raw;           /* am Ende exakt der Originaltext */
      };
      write(0);
      requestAnimationFrame(step);
    };
    ScrollTrigger.create({ trigger: el, start: "top 90%", once: true, onEnter: run });
  });

  /* ---- Produktkarten steigen gestaffelt auf ---- */
  var grid = document.querySelector(".prodgrid");
  if (grid) {
    gsap.fromTo(grid.children, { y: 34, opacity: 0 }, {
      y: 0, opacity: 1, duration: 1, ease: "power3.out", stagger: .12,
      scrollTrigger: { trigger: grid, start: "top 82%", once: true }
    });
  }

  /* ---- Laufband ---- */
  [].forEach.call(document.querySelectorAll(".marquee-track"), function (track) {
    var first = track.firstElementChild;
    if (!first) return;
    var w = first.getBoundingClientRect().width;
    if (!w) return;
    gsap.to(track, { x: -w, duration: w / 34, ease: "none", repeat: -1 });
  });

  ScrollTrigger.refresh();
  window.addEventListener("load", function () { ScrollTrigger.refresh(); });
})();
